import React from "react";

const PaymentModal = ({ onClose }) => {
  return (
    <div
      className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div
          class="modal-content"
          style={{
            maxWidth: "500px",
            marginInline: "auto",
          }}
        >
          <div class="modal-header border-0 p-0 pb-2">
            <button
              type="button"
              class="btn-close ct_close_position_right12"
              onClick={onClose}
            ></button>
          </div>
          <div class="modal-body ">
            <section class="ct_signup_main py-3">
              <div class="container-fluid">
                <div class="row ">
                  <div class="col-xxl-12 mx-auto ">
                    <div class="ct_signup_right_content px-2 ct_custom_scroll h-auto">
                      <div class="ct_signup_logo mb-3">
                        <img src="../assets/img/Nuvio_logo.png" alt="" />
                      </div>
                      <ul className="mt-4">
                        <li className="text-center">
                          <p className="mb-2 ct_white_nowrap ct_fw_600 ct_fs_24">
                            Reserve Your Seat{" "}
                          </p>
                          <p className="mb-0 ct_fs_24">
                            You’re almost there! Please check your email for
                            bank transfer details to reserve your seat.{" "}
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
